import { render, staticRenderFns } from "./SupportTicketConversationHeader.vue?vue&type=template&id=6c722226&"
import script from "./SupportTicketConversationHeader.vue?vue&type=script&lang=js&"
export * from "./SupportTicketConversationHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports